import React from 'react';
interface SecretProps {
  number: number;
  title: string;
  image: string;
  quote: string;
  partner: string;
  content: string;
}
export function Secret({
  number,
  title,
  image,
  quote,
  partner,
  content
}: SecretProps) {
  return <div className="border-b border-gray-200 pb-10" data-id="element-53">
      <div className="flex flex-col md:flex-row md:items-center gap-6" data-id="element-54">
        <div className="md:w-1/3" data-id="element-55">
          <div className="relative" data-id="element-56">
            <img src={image} alt={`Secret ${number}`} className="rounded-lg shadow-md w-full" data-id="element-57" />
            <div className="absolute -top-4 -left-4 w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-xl" data-id="element-58">
              {number}
            </div>
          </div>
        </div>
        <div className="md:w-2/3" data-id="element-59">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3" data-id="element-60">
            {title}
          </h3>
          <div className="bg-gray-100 p-4 rounded-lg mb-4 italic" data-id="element-61">
            <p className="text-gray-800" data-id="element-62">{quote}</p>
            <p className="text-gray-600 text-right mt-2" data-id="element-63">{partner}</p>
          </div>
          <p className="text-gray-700 leading-relaxed" data-id="element-64">{content}</p>
        </div>
      </div>
    </div>;
}